import { IconContent } from '@icons';

export const padlockToggleOpened: IconContent = {
    sm: '<path fill-rule="evenodd" clip-rule="evenodd" d="M3.5 1C4.88071 1 6 2.11929 6 3.5V7H4H3V8V15V16H4H14H15V15V8V7H14H7V3.5C7 1.567 5.433 0 3.5 0C1.567 0 0 1.567 0 3.5V5H1V3.5C1 2.11929 2.11929 1 3.5 1ZM6 8H7H14V15H4V8H6ZM9.5 12.9143V10H8.5V12.9143H9.5Z" fill-opacity="0.6"/>',
};
